export const uniformGenderOptions = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "U", label: "Unisex" }
]

export const issuanceStatusOptions = [
    { value: "PENDING", label: "Pending" },
    { value: "ISSUED", label: "Issued" },
    { value: "ACCEPTED", label: "Accepted" },
    { value: "REJECTED", label: "Rejected" },
    { value: "RETURNED", label: "Returned" }
]

export const transferStatusOptions = [
    { value: "PENDING", label: "Pending" },
    { value: "COMPLETED", label: "Completed" },
    { value: "CANCELLED", label: "Cancelled" }
]

export const stockTakeStatusOptions = [
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "COMPLETED", label: "Completed" }
]

export const transactionTypeOptions = [
    { value: "RECEIVING", label: "Receiving" },
    { value: "ISSUANCE", label: "Issuance" },
    { value: "RETURN", label: "Return" },
    { value: "TRANSFER_IN", label: "Transfer In" },
    { value: "TRANSFER_OUT", label: "Transfer Out" },
    { value: "ADJUSTMENT", label: "Adjustment" }
]

export const rejectionReasonOptions = [
    { value: "SIZE_TOO_SMALL", label: "Size Too Small" },
    { value: "SIZE_TOO_LARGE", label: "Size Too Large" },
    { value: "INCORRECT_UNIFORM", label: "Incorrect Uniform" },
    { value: "DAMAGED", label: "Damaged" },
    { value: "INCORRECT_GENDER", label: "Incorrect Gender" },
    { value: "OTHER", label: "Other" }
]

export const reviewStatusOptions = [
    { value: "APPROVED", label: "Approved" },
    { value: "DENIED", label: "Denied" }
]

export const activeStatusOptions = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" }
]

export const statusBadgeMap = {
    PENDING: { color: "#faad14", bg: "#fffbe6", border: "#ffe58f" },
    ISSUED: { color: "#1890ff", bg: "#e6f7ff", border: "#91d5ff" },
    ACCEPTED: { color: "#52c41a", bg: "#f6ffed", border: "#b7eb8f" },
    REJECTED: { color: "#ff4d4f", bg: "#fff2f0", border: "#ffa39e" },
    RETURNED: { color: "#722ed1", bg: "#f9f0ff", border: "#d3adf7" },
    COMPLETED: { color: "#52c41a", bg: "#f6ffed", border: "#b7eb8f" },
    CANCELLED: { color: "#8c8c8c", bg: "#fafafa", border: "#d9d9d9" },
    IN_PROGRESS: { color: "#faad14", bg: "#fffbe6", border: "#ffe58f" },
    NOT_ISSUED: { color: "#8c8c8c", bg: "#fafafa", border: "#d9d9d9" }
}

export const getStatusBadge = (status) => {
    const style = statusBadgeMap[status] || statusBadgeMap.NOT_ISSUED
    return {
        backgroundColor: style.bg,
        color: style.color,
        border: `1px solid ${style.border}`,
        borderRadius: "4px",
        padding: "2px 8px",
        fontSize: "12px",
        fontWeight: 500
    }
}
